import { render, staticRenderFns } from "./ReactivateAccount.vue?vue&type=template&id=ac97dd52&scoped=true"
import script from "./ReactivateAccount.vue?vue&type=script&lang=ts"
export * from "./ReactivateAccount.vue?vue&type=script&lang=ts"
import style0 from "./ReactivateAccount.vue?vue&type=style&index=0&id=ac97dd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac97dd52",
  null
  
)

export default component.exports